import { ChangeDetectionStrategy, Component, ElementRef, Inject, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { Popup } from '../../../core/popup/popup.model';
import { resolveStoreUrl } from '../../../core/platform/store-url.util';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-seasonal-popup',
  templateUrl: './seasonal-popup.component.html',
  styleUrls: ['./seasonal-popup.component.css'],
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeasonalPopupComponent implements OnDestroy {
  private _el = inject(ElementRef<HTMLElement>);
  private _exitTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(
    @Inject(DIALOG_DATA) public popup: Popup,
    private _dialogRef: DialogRef<SeasonalPopupComponent>,
  ) {}

  ngOnDestroy(): void {
    if (this._exitTimer !== null) {
      clearTimeout(this._exitTimer);
    }
  }

  onImageClick(): void {
    // Sentinela STORE_AUTO (pop-up "descarga la app", frente #2): enruta a la
    // tienda correcta por user-agent. El admin puede sobrescribir poniendo una
    // URL real en clickActionUrl en vez de STORE_AUTO.
    const url =
      this.popup.clickActionUrl === 'STORE_AUTO'
        ? resolveStoreUrl(navigator.userAgent, {
            appStoreUrl: environment.appStoreUrl,
            playStoreUrl: environment.playStoreUrl,
          })
        : this.popup.clickActionUrl;

    if (url.startsWith('/')) {
      window.location.href = url;
    } else {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
    this._closeWithAnimation();
  }

  close(): void {
    this._closeWithAnimation();
  }

  private _closeWithAnimation(): void {
    const container = this._el.nativeElement.querySelector('.popup-container') as HTMLElement | null;
    if (container) {
      container.style.animation = 'popup-exit 200ms ease-in forwards';
    }
    this._exitTimer = setTimeout(() => {
      this._exitTimer = null;
      this._dialogRef.close();
    }, 190);
  }
}
